// extracted by mini-css-extract-plugin
export var closeButtonContainer = "Modal_closeButtonContainer__SxqPP";
export var modalContent = "Modal_modalContent__EVoZT";
export var openBody = "Modal_openBody__wu5Cm";
export var shared = "'../shared.module.css'";
export var sm = "576px";